import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material"
import { BaseProduct } from "services/batchService"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"

interface CreateBatchDialogProps {
  openDialog: boolean
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>
  isSaving: boolean
  batchForm: { batchId: number; scheduledDate: string }
  setBatchForm: React.Dispatch<React.SetStateAction<{ batchId: number; scheduledDate: string }>>
  handleSubmitBatch: (values: { batchId: number; scheduledDate: string }) => void
  scheduledDate: string
  selectedProduct: BaseProduct | undefined
}

const CreateBatchDialog: React.FC<CreateBatchDialogProps> = ({
  openDialog,
  setOpenDialog,
  isSaving,
  batchForm,
  setBatchForm,
  handleSubmitBatch,
  scheduledDate,
  selectedProduct,
}) => {
  const validationSchema = Yup.object().shape({
    batchId: Yup.number()
      .required("O lote é obrigatório")
      .integer("O lote deve ser um número inteiro"),
  })

  console.log(scheduledDate)
  return (
    <Dialog
      open={openDialog}
      onClose={() => !isSaving && setOpenDialog(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Novo Lote - {selectedProduct?.productBaseName}</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={batchForm}
          validationSchema={validationSchema}
          onSubmit={values => {
            handleSubmitBatch(values)
            setOpenDialog(false)
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
                <Field name="batchId">
                  {({ field, meta }: any) => (
                    <TextField
                      label="Lote"
                      {...field}
                      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                      value={batchForm.batchId}
                      onChange={e => {
                        const value = e.target.value.replace(/\D/g, "")
                        setBatchForm({ ...batchForm, batchId: Number(value) })
                      }}
                      InputLabelProps={{ style: { color: "#F8974C" } }}
                      fullWidth
                      disabled={isSaving}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
                <Field name="scheduledDate">
                  {({ field, meta }: any) => (
                    <TextField
                      label="Data de Entrega"
                      type="date"
                      value={scheduledDate}
                      {...field}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      disabled={true}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
              </Box>
              <DialogActions>
                <Button
                  onClick={() => setOpenDialog(false)}
                  sx={{ color: "text.primary" }}
                  disabled={isSaving}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  disabled={isSaving || !batchForm.batchId}
                  startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  {isSaving ? "Salvando..." : "Criar"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default CreateBatchDialog
